<template lang="pug">
	dx-validation-group.keywords-suggester
		Stepper(ref="stepper", :steps="steps", :subStepsVisible="false", @step-changed="onStepChanged")
		DxScrollView(showScrollbar="always", height="280px")
			.content
				.helper-content
					template(v-if="currentStepIndex === 0")
						.header {{$tCaption('Is your advertiser\'s category correct? It is based on the industry you selected?')}}
						.data.flex-row.align-center
							Loader(v-if="!categories.length", :text="$tCaption('Loading') + '..'")
							DxSelectBox.flex-1(v-else, :items="categories", @value-changed="v => selected.advertiserIndustry = v.value", :search-enabled="true", :value="selected.advertiserIndustry")
					template(v-if="currentStepIndex === 1")
						.header {{$tCaption('What is your advertiser\'s name?')}}
						.data
							DxTextBox.flex-1(@value-changed="v => selected.advertiserName = v.value", :value="selected.advertiserName")
						.header {{$tCaption('What is your advertiser\'s website url?')}}
						.data
							DxTextBox.flex-1(@value-changed="v => selected.url = v.value", :value="selected.url", placeholder="Enter url..")
								dx-validator
									dx-required-rule(:message="$tCaption('Field is required', '@actions')")
					template(v-if="currentStepIndex == 2")
						.header {{$tCaption('Based on your category, we\'ve provided a few suggestions of keywords. Are we missing any?')}}
						.sub-header {{$tCaption('Enter new ideas or remove the ones that aren\'t relevant.')}}
						.data
							DxTagBox.flex-1(
								:items="keywords",
								:accept-custom-value="true",
								:search-enabled="true",
								:value="selected.ideas",
								:show-selection-controls="true",
								@value-changed="v => selected.ideas = v.value")
								DxTagBoxButton(v-if="selected.ideas.length", name="clearAll", :options="{text: '', icon: 'clear', type: 'default', onClick: () => selected.ideas = []}")
					template(v-if="currentStepIndex === 3")
						.header {{$tCaption('Enter the advertiser\'s Competitors website to search any additional keywords.')}}
						.data.flex-row.space
							DxTextBox.flex-1(@value-changed="v => selected.competitorUrl = v.value", :value="selected.competitorUrl", :placeholder="$tCaption('Enter url') + '..'", valueChangeEvent="input")
							DxLoadIndicator(v-if="isLoading", :height="20", :width="20")
							DxButton(v-else, :text="$tCaption('Load keywords')", icon="chevrondoubleright", @click="() => loadCompetitorsKeywords()", type="default", :disabled="!selected.competitorUrl")
						template(v-if="competitorsKeywords.length")
							.header {{$tCaption('Competitor\'s site keywords.')}}
							.data
								DxTagBox.flex-1(
									:items="competitorsKeywords",
									:accept-custom-value="true",
									:search-enabled="true",
									:value="selected.competitorsKeywords",
									:show-selection-controls="true",
									@value-changed="v => selected.competitorsKeywords = v.value")
									DxTagBoxButton(v-if="selected.competitorsKeywords.length", name="clearAll", :options="{text: '', icon: 'clear', type: 'default', onClick: () => selected.competitorsKeywords = []}")
					template(v-if="currentStepIndex == 4")
						.header {{$tCaption('Enter a keyword word to find related keywords.')}}
						.data
							DxTextBox.flex-1(@value-changed="v => { selected.keyword = v.value; $forceUpdate(); }", :value="selected.keyword", valueChangeEvent="input", :placeholder="$tCaption('Enter word or phrase..')")
						.header {{$tCaption('Related keywords')}}
						.data
							DxTagBox.flex-1(
								:disabled="!relatedKeywords.length",
								:items="relatedKeywords",
								:accept-custom-value="true",
								:search-enabled="true",
								:value="selected.relatedKeywords",
								:show-selection-controls="true",								
								@value-changed="v => selected.relatedKeywords = v.value")
								DxTagBoxButton(v-if="selected.relatedKeywords.length", name="clearAll", :options="{text: '', icon: 'clear', type: 'default', onClick: () => selected.relatedKeywords = []}")
		.buttons
			.left-block
				DxButton(v-if="currentStepIndex > 0", text="Back", icon="chevrondoubleleft", @click="() => $refs.stepper.prevStep()", type="normal")
			.right-block.flex-row.space.align-center
				template(v-if="isLoading")
					DxLoadIndicator(:height="20", :width="20")
				template(v-else)
					DxButton(:text="$tCaption('Cancel', '@actions')", @click="$emit('cancel')")
					DxButton(v-if="currentStepIndex < steps.length - 1", :text="$tCaption('Next')", icon="chevrondoubleright", @click="nextStep", type="default")
					DxButton(v-if="currentStepIndex === steps.length - 1", :text="selected.keyword && !selected.relatedKeywords.length ? $tCaption('Get keywords') : $tCaption('Finish')", icon="chevrondoubleright", @click="() => getKeywords()", type="default")
			slot(name="actions")
</template>
<script>
	import VueTypes from 'vue-types';
	import { DxTagBox, DxButton as DxTagBoxButton  } from 'devextreme-vue/tag-box';
	import DxButton from 'devextreme-vue/button';
	import { DxPopup } from 'devextreme-vue/popup';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import Stepper from 'view/proposal/Stepper.vue';
	import Data from 'app-core/Data';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
	import Promise from 'bluebird';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'proposal.KeywordsSuggester',
		name: 'keywords-suggester',
		components: {
			DxButton,
			DxTagBox,
			DxTagBoxButton,
			DxPopup,
			DxScrollView,
			Stepper,
			DxSelectBox,
			DxTextBox,
			DxLoadIndicator,
			DxValidator,
			DxRequiredRule,
			DxCustomRule,
			DxValidationGroup,
			Loader
		},
		props: {
			data: VueTypes.object.def({})
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				popupVisible: false,
				currentStepIndex: 0,
				isLoading: false,
				steps: [
					{
						name: this.$tCaption('Category'),
						icon: 'fas fa-check-double',
						steps: [
							{ name: this.$tCaption('Category') }
						]
					},
					{
						name: this.$tCaption('Advertiser'),
						icon: 'fas fa-at',
						steps: [
							{ name: this.$tCaption('Advertiser') }
						]
					},
					{
						name: this.$tCaption('Ideas'),
						icon: 'fas fa-lightbulb',
						steps: [
							{ name: this.$tCaption('Ideas') }
						]
					},
					{
						name: this.$tCaption('Competitors'),
						icon: 'fas fa-user-friends',
						steps: [
							{ name: this.$tCaption('Competitors') }
						]
					},
					{
						name: this.$tCaption('Related keywords'),
						icon: 'fas fa-link',
						steps: [
							{ name: this.$tCaption('Related keywords') }
						]
					}
				],
				categories: [],
				selected: {
					advertiserIndustry: this.data.advertiserIndustry,
					advertiserName: this.data.advertiserName,
					url: null,
					ideas: [],
					competitorUrl: null,
					competitorsKeywords: [],
					relatedKeywords: []
				},
				keywords: [],
				competitorsKeywords: [],
				relatedKeywords: []
			};
		},
		computed: {
			suggestedKeywords() {
				return [
					this.selected.advertiserIndustry,
					this.selected.advertiserName,
					...this.selected.ideas,
					...this.selected.competitorsKeywords,
					...this.selected.relatedKeywords
				].filter(f => !!f);
			}
		},
		watch: {
			'selected.advertiserIndustry'(v) {
				this.$emit('industry-selected', v);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.keywordsSuggester = this;
			Data.loadIabCategories().then(r => {
				const parent = r.filter(f => f.Code === '90')[0];
				this.categories = _.orderBy(r.filter(f => f.ParentId === parent.Oid), ['Name']).map(f => f.Name);
			});
		},
		methods: {
			onStepChanged(v, pos) {
				this.currentStepIndex = pos[0];
			},
			nextStep(e) {
				if (!e?.validationGroup?.validate().isValid) {
					return;
				}
				if (this.currentStepIndex === 1) {
					this.loadKeywords().finally(() => this.$refs.stepper.nextStep());
				} else {
					this.$refs.stepper.nextStep();
				}
			},
			loadKeywords() {
				if (!this.selected.url) return Promise.resolve(null);
				this.isLoading = true;
				return Data.getExternalApi('CloudApiKeywords/getDomainKeywords', `domain=${this.selected.url}`).then(r => {
					if (__DEBUG__)
						console.log('getDomainKeywords loaded', r);
					if (this._isDestroyed) return;

					this.keywords = r.sort((a,b) => a.Position - b.Position).map(f => f.Term);
					if (!this.selected.ideas.length) {
						this.selected.ideas = r.sort((a,b) => a.Position - b.Position).slice(0,10).map(f => f.Term);
					}
				}).finally(() => this.isLoading = false);
			},
			loadRelativeKeywords() {
				if (!this.selected.keyword) return Promise.resolve(null);
				this.isLoading = true;
				return Data.getExternalApi('CloudApiKeywords/getRelatedKeywords', `sourceKeyword=${this.selected.keyword}`).then(r => {
					if (__DEBUG__)
						console.log('getRelatedKeywords loaded', r);
					if (this._isDestroyed) return;

					this.relatedKeywords = r.sort((a,b) => a.Position - b.Position).map(f => decodeURIComponent(f.Keyword));
					if (!this.selected.relatedKeywords.length) {
						this.selected.relatedKeywords = r.sort((a,b) => a.Position - b.Position).slice(0,10).map(f => decodeURIComponent(f.Keyword));
					}
				}).finally(() => this.isLoading = false);
			},
			loadCompetitorsKeywords() {
				if (!this.selected.competitorUrl) return Promise.resolve(null);
				this.isLoading = true;
				return Data.getExternalApi('CloudApiKeywords/getDomainKeywords', `domain=${this.selected.competitorUrl}`).then(r => {
					if (__DEBUG__)
						console.log('getDomainKeywords loaded', { domain: this.selected.competitorUrl, data: r });
					if (this._isDestroyed) return;

					this.competitorsKeywords = r.sort((a,b) => a.Position - b.Position).map(f => f.Term);
					if (!this.selected.competitorsKeywords.length) {
						this.selected.competitorsKeywords = r.sort((a,b) => a.Position - b.Position).slice(0,10).map(f => f.Term);
					}
				}).finally(() => this.isLoading = false);
			},
			getKeywords() {
				if (this.selected.keyword && !this.selected.relatedKeywords.length) {
					this.loadRelativeKeywords();	
				} else {				
					this.$emit('get-keywords', this.suggestedKeywords);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.keywords-suggester {
		.stepper-item {
			border-radius: 10px;
			flex: auto;
		}

		.helper-content {
			padding: 20px;

			.header {
				font-size: 20px;
				font-weight: 100;
				margin-top: 20px;
			}

			.sub-header {
				font-size: 16px;
				font-weight: 100;
			}

			.data {
				margin: 5px 0px 5px 0px;
				display: flex;

				.flex-1 {
					flex: 1;
				}
			}
		}

		.stepper-component .stepper::before {
			background: #fff;
		}

		> .buttons {
			position: absolute;
			bottom: 0px;
			width: 100%;
			padding: 20px;
			display: flex;
			justify-content: space-between;
		}
	}
</style>
